import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { CloseCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import { Button, Card, Popover, Modal, Spin } from 'hljd'
import style from './style.module.less'
import { switchCase, getObjValue } from '@hlj/hlj-utils'
import store from './store'
import { observer } from 'mobx-react'
import { Link } from 'react-router'

@observer
export default class extends Component {
  componentDidMount() {
    store.getVerList()
  }

  render() {
    const header = [
      <Link to="/localMerchant/liteApp/manage">小程序</Link>,
      '小程序管理'
    ]

    const {
      official_version,
      audit_version,
      visible,
      modal_type,
      user_info,
      category,
      loading,
      QRCodeVisible,
      QRCodePath
    } = store

    const official_category = (category || [])
      .filter(
        (item, index) => index == +getObjValue(official_version, 'category_id')
      )
      .map(({ first_class, second_class, third_class }) => ({
        first_class,
        second_class,
        third_class
      }))
    const audit_category = (category || [])
      .filter(
        (item, index) => index == +getObjValue(audit_version, 'category_id')
      )
      .map(({ first_class, second_class, third_class }) => ({
        first_class,
        second_class,
        third_class
      }))

    return (
      <HeaderView header={header} title="小程序版本">
        {loading ? (
          <div className={style.loading}>
            <Spin size="large" />
          </div>
        ) : (
          <div className={style.audit}>
            <Card
              title={
                <p className={style.head}>
                  线上版本<span>
                    (线上已经发布的小程序版本，可通过修改小程序直接更改前端展示页面)
                  </span>
                </p>
              }
              extra={
                <Button
                  style={{ height: 32, width: 90 }}
                  onClick={store.showModal('remove')}
                >
                  解除授权
                </Button>
              }
              style={{ marginBottom: 20 }}
            >
              {official_version ? (
                <dl>
                  <dt>小程序</dt>
                  <dd>
                    {user_info.nick_name}
                    <p>可以在微信里搜索你的小程序名称，访问你的小程序</p>
                  </dd>
                  <dt>线上版本</dt>
                  <dd>{getObjValue(official_version, 'user_version')}</dd>
                  <dt>二维码</dt>
                  <dd>
                    <div
                      className={style.qrcode}
                      onClick={store.showQrCode(
                        getObjValue(official_version, 'qrcode_url')
                      )}
                    >
                      <img
                        style={{ width: 80, height: 80 }}
                        src={getObjValue(official_version, 'qrcode_url')}
                      />
                    </div>
                    <a
                      href={getObjValue(official_version, 'qrcode_url')}
                      className={style.downQrCode}
                    >
                      <img src="http://qnm.hunliji.com/o_1bo9m3b9s1ch4972q3a1h814tth.png" />
                    </a>
                    <p>小程序已上线，扫码访问</p>
                  </dd>
                  <dt>提交时间</dt>
                  <dd style={{ height: 21 }}>
                    {getObjValue(official_version, 'created_at')}
                  </dd>
                  <dt>所选分类</dt>
                  {/*<dd>{category.length>0 && `${getObjValue(category[official_version.category_id],'first_class')}${`-${getObjValue(category[official_version.category_id],'second_class')}`}${`-${getObjValue(category[official_version.category_id],'third_class')}`}`}</dd>*/}
                  <dd>
                    {official_category.length > 0 &&
                      Object.values(official_category[0])
                        .filter(item => item)
                        .join('-')}
                  </dd>
                </dl>
              ) : (
                <dl>
                  <dt>线上版本</dt>
                  <dd>无已发布版本</dd>
                </dl>
              )}
            </Card>
            <Card
              title={
                <p className={style.head}>
                  {audit_version
                    ? switchCase(
                        getObjValue(audit_version, 'audit_info.status') + '',
                        {
                          '0': (
                            <i
                              className={style.status}
                              style={{
                                color: '#04964d',
                                borderColor: '#04964d'
                              }}
                            >
                              审核通过
                            </i>
                          ),
                          '1': (
                            <i className={style.status}>
                              审核不通过
                              <Popover
                                placement="bottom"
                                title={
                                  <p style={{ fontWeight: 700 }}>
                                    <CloseCircleOutlined
                                      style={{
                                        color: '#f04134',
                                        marginRight: 5,
                                        fontWeight: 'normal'
                                      }}
                                    />审核失败原因
                                  </p>
                                }
                                content={
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: getObjValue(
                                        audit_version,
                                        'audit_info.reason'
                                      )
                                    }}
                                  />
                                }
                                trigger="hover"
                              >
                                <QuestionCircleOutlined
                                  style={{ color: '#ffbf00', marginLeft: 5 }}
                                />
                              </Popover>
                            </i>
                          ),
                          '2': <i className={style.status}>审核中</i>
                        }
                      )
                    : null}
                  审核版本<span>
                    (正在微信审核中的版本，一次只能审核一个版本，审核通过后才能发布至线上)
                  </span>
                </p>
              }
              style={{ marginBottom: 20 }}
            >
              {audit_version ? (
                <dl>
                  <dt>小程序</dt>
                  <dd style={{ height: 21 }}>{user_info.nick_name}</dd>
                  <dt>提交时间</dt>
                  <dd style={{ height: 21 }}>{audit_version.updated_at}</dd>
                  <dt>所选分类</dt>
                  {/*<dd >{category.length>0 && `${getObjValue(category[audit_version.category_id],'first_class')}${`-${getObjValue(category[audit_version.category_id],'second_class')}`}${`-${getObjValue(category[audit_version.category_id],'third_class')}`}`}</dd>*/}
                  <dd>
                    {audit_category.length > 0 &&
                      Object.values(audit_category[0])
                        .filter(item => item)
                        .join('-')}
                  </dd>
                </dl>
              ) : (
                <dl>
                  <dt>审核版本</dt>
                  <dd>无审核版本</dd>
                </dl>
              )}
            </Card>
            {/*<Card*/}
            {/*title={*/}
            {/*<p className={style.head}>*/}
            {/*测试版本<span>*/}
            {/*(修改测试版本，可在婚礼纪平台调整小程序样式，再提交审核发布至线上)*/}
            {/*</span>*/}
            {/*</p>*/}
            {/*}*/}
            {/*extra={*/}
            {/*<div>*/}
            {/*<Button style={{ height: 32 }} onClick={store.toModify}>*/}
            {/*修改小程序*/}
            {/*</Button>*/}
            {/*<Button*/}
            {/*style={{*/}
            {/*height: 32,*/}
            {/*width: 90,*/}
            {/*marginLeft: 12,*/}
            {/*display: getObjValue(test_version, 'qrcode_url')*/}
            {/*? 'inline-block'*/}
            {/*: 'none'*/}
            {/*}}*/}
            {/*type="primary"*/}
            {/*onClick={store.showModal('audit')}*/}
            {/*>*/}
            {/*提交审核*/}
            {/*</Button>*/}
            {/*</div>*/}
            {/*}*/}
            {/*>*/}
            {/*{getObjValue(test_version, 'qrcode_url') ? (*/}
            {/*<dl>*/}
            {/*<dt>二维码</dt>*/}
            {/*<dd>*/}
            {/*<div*/}
            {/*className={style.qrcode}*/}
            {/*onClick={store.showQrCode(test_version.qrcode_url)}*/}
            {/*>*/}
            {/*<img*/}
            {/*style={{ width: 80, height: 80 }}*/}
            {/*src={test_version.qrcode_url}*/}
            {/*/>*/}
            {/*</div>*/}
            {/*<a*/}
            {/*href={test_version.qrcode_url}*/}
            {/*className={style.downQrCode}*/}
            {/*>*/}
            {/*<img src="http://qnm.hunliji.com/o_1bo9m3b9s1ch4972q3a1h814tth.png" />*/}
            {/*</a>*/}
            {/*<p>体验版小程序已生成，请点击提交审核</p>*/}
            {/*</dd>*/}
            {/*<dt>修改时间</dt>*/}
            {/*<dd style={{ height: 21 }}>{test_version.updated_at}</dd>*/}
            {/*<dt>所选分类</dt>*/}
            {/*/!*<dd>{category.length>0&& `${getObjValue(category[test_version.category_id],'first_class')}${`-${getObjValue(category[test_version.category_id],'second_class')}`}${`-${getObjValue(category[test_version.category_id],'third_class')}`}`}</dd>*!/*/}
            {/*<dd>*/}
            {/*{test_category.length > 0 &&*/}
            {/*Object.values(test_category[0])*/}
            {/*.filter(item => item)*/}
            {/*.join('-')}*/}
            {/*</dd>*/}
            {/*</dl>*/}
            {/*) : (*/}
            {/*<dl>*/}
            {/*<dt>体验版本</dt>*/}
            {/*<dd>无体验版本</dd>*/}
            {/*</dl>*/}
            {/*)}*/}
            {/*</Card>*/}
          </div>
        )}
        <Modal
          visible={visible}
          title={
            <p style={{ fontSize: 16 }}>
              <LegacyIcon
                type={modal_type === 2 ? 'close-circle' : 'question-circle'}
                style={{
                  color: '#f04134',
                  fontSize: 18,
                  marginRight: 10,
                  verticalAlign: 'bottom'
                }}
              />
              {modal_type === 2 ? '提交审核失败' : '提示'}
            </p>
          }
          closable={false}
          maskClosable={false}
          width={400}
          footer={[
            <Button key="back" onClick={store.cancel}>
              取消
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={store.submit(modal_type)}
            >
              确认
            </Button>
          ]}
        >
          <p style={{ height: 50, fontSize: 14 }}>
            {switchCase(modal_type + '', {
              '1':
                '解除授权后，本平台配置的小程序将不可再使用。确认继续解除授权？',
              '2': '只有选择分类之后才能提审，是否前往微信小程序后台选择分类？',
              '3':
                '提交审核后本次提交将无法撤销和修改，请确保内容源和页面都已正确配置。'
            })}
          </p>
        </Modal>

        <Modal
          visible={QRCodeVisible}
          closable={false}
          footer={null}
          width={460}
          onCancel={store.cancelQrCode}
        >
          <img src={QRCodePath} />
        </Modal>
      </HeaderView>
    )
  }
}
